import React from 'react';
import { Input } from '@deere/fuel-react';

export const EditAnnouncement = ({ selectedAnnouncement, setSelectedAnnouncement }) => (
    <>
        <strong>Announcement Type</strong>
        <br />
        <span>{selectedAnnouncement.announcementType}</span>
        <br />
        <br />
        <strong>Announcement</strong>
        <br />
        <Input
            onChange={(event) => {
                setSelectedAnnouncement(prevState => ({
                    ...prevState,
                    announcement: event.target.value
                }));
            }}
            defaultValue={selectedAnnouncement.announcement}
            label={"Text Value"}
            multiline={true}
            aria-multiline={true}
            placeholder={"Type an announcement"}
            minRows={4}
            fullWidth
        />
        <span>for putting in links use [text](https://example_url.com)</span><br/>
        <span>for putting in emails use [text](mailto:example@email.com)</span>
    </>
);
